module.exports = __webpack_public_path__ + "static/media/dpd-courier.62514464.svg";